import { render, staticRenderFns } from "./CreateActivityTemplate.vue?vue&type=template&id=1edae2f2&scoped=true"
import script from "./CreateActivityTemplate.vue?vue&type=script&lang=js"
export * from "./CreateActivityTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreateActivityTemplate.vue?vue&type=style&index=0&id=1edae2f2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edae2f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1edae2f2')) {
      api.createRecord('1edae2f2', component.options)
    } else {
      api.reload('1edae2f2', component.options)
    }
    module.hot.accept("./CreateActivityTemplate.vue?vue&type=template&id=1edae2f2&scoped=true", function () {
      api.rerender('1edae2f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/ActivityTemplate/CreateActivityTemplate.vue"
export default component.exports